// cleanSlate collapse — trigger click delegate.
//
// cleanSlate extends base directly and ships no underlying CSS framework, so —
// unlike bootstrap5, where Bootstrap's own document-level handler toggles
// data-bs-toggle="collapse" triggers — nothing would wire the collapse clicks.
// The behaviour contract says a delegate-less tier MUST provide this itself
// (core/themes/base/scripts/behaviors.{js,contract.md}, collapse note), so this is
// cleanSlate's frameworkless replacement for that delegate. The state side (token
// names + initial classes) lives in behaviors.collapse; here we only handle clicks.
//
// A region opts in with [data-zit-collapsible]; its trigger carries
// data-zit-toggle="collapse" + data-zit-collapse-target="#<regionId>" — the same
// markup the theme-neutral window-family components (widgetsList/itemsList/…) and
// the generic window (controller/partials/window.tpl) emit. One delegated listener
// covers every trigger, including ones inserted after boot. CSP-safe.
export default function initCollapse(hm) {
    document.addEventListener('click', function (event) {
        // the nearest collapse trigger for this click, if any
        const trigger = event.target.closest('[data-zit-toggle="collapse"]');

        if (!trigger) {
            return;
        }

        // resolve the region the trigger controls (a CSS selector, e.g. #x_bodyHolder)
        const selector = trigger.getAttribute('data-zit-collapse-target');
        const region = selector ? document.querySelector(selector) : null;

        if (!region) {
            return;
        }

        // a collapse toggle never navigates (a trigger may be an <a href="#">)
        event.preventDefault();

        // toggle the region between the theme's shown/hidden state classes
        const collapse = hm.behaviors.collapse;
        const shownClass = collapse.stateClass('shown');
        const hiddenClass = collapse.stateClass('hidden');
        const isShown = region.classList.contains(shownClass);

        region.classList.toggle(shownClass, !isShown);
        region.classList.toggle(hiddenClass, isShown);

        // keep aria-expanded in sync (also drives the chevron rotation via CSS)
        trigger.setAttribute('aria-expanded', isShown ? 'false' : 'true');
    });
}
